import React from 'react'
import FormReport from "../../../../../../components/pages/inventory/ReportInventory";
import { useFetch } from '../../../../../../hooks/useFetch';

export default () => {

    return (
        <FormReport
            title={'Import Custome Module'}
            repType={'custome_module'}
            url={"/api/v1/report_import"}
            FetchComponent={useFetch}
        />
    )
}